import { render, staticRenderFns } from "./FotoTextoLanding.vue?vue&type=template&id=a6474868&scoped=true&"
import script from "./FotoTextoLanding.vue?vue&type=script&lang=js&"
export * from "./FotoTextoLanding.vue?vue&type=script&lang=js&"
import style0 from "./FotoTextoLanding.vue?vue&type=style&index=0&id=a6474868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6474868",
  null
  
)

export default component.exports